<template>
  <div class="bg-[#fafafa] flex items-center h-screen w-full">
    <main class="flex-1 h-full overflow-auto flex flex-col px-2 py-1 gap-14">
      <nav class="">
        <figure class="aspect-[5/2] w-[190px]">
          <a href="https://web.writewise.io" target="_blank">
            <img :src="logo" alt="" class="w-full h-full object-contain" />
          </a>
        </figure>
      </nav>

      <div class="flex-1 w-full grid place-items-center">
        <router-view></router-view>
      </div>
    </main>

    <aside class="auth_image_container flex-1 hidden lg:grid h-screen bg-gradient-to-t place-items-center">
      <figure class="aspect-square w-full">
        <a href="https://web.writewise.io" target="_blank">
          <img :src="auth_image" alt="" class="w-full h-full object-contain" />
        </a>
      </figure>
    </aside>
  </div>
</template>

<script lang="ts">
import { Vue } from 'vue-class-component';
import logo from '@/assets/images/writewise_logo.png';
import auth_image from '@/assets/images/auth_image.png';

export default class AuthLayout extends Vue {
  public logo = logo;
  public auth_image = auth_image;
}
</script>
<style scoped>
.auth_image_container {
  background: -moz-linear-gradient(top,
      rgba(33, 145, 218, 1) 0%,
      rgba(34, 88, 187, 1) 100%);
  /* FF3.6+ */
  background: -webkit-gradient(linear,
      left top,
      left bottom,
      color-stop(0%, rgba(34, 88, 187, 1)),
      color-stop(100%, rgba(33, 145, 218, 1)));
  /* Chrome,Safari4+ */
  background: -webkit-linear-gradient(top,
      rgba(33, 145, 218, 1) 0%,
      rgba(34, 88, 187, 1) 100%);
  /* Chrome10+,Safari5.1+ */
  background: -o-linear-gradient(top,
      rgba(33, 145, 218, 1) 0%,
      rgba(34, 88, 187, 1) 100%);
  /* Opera 11.10+ */
  background: -ms-linear-gradient(top,
      rgba(33, 145, 218, 1) 0%,
      rgba(34, 88, 187, 1) 100%);
  /* IE10+ */
  background: linear-gradient(to bottom, rgba(33, 145, 218, 1) 0%, rgba(34, 88, 187, 1) 100%);
}
</style>
